module.exports = __webpack_public_path__ + "img/1.PU.2ff1d97b.jpg";